import { render, staticRenderFns } from "./LvInfoBox.vue?vue&type=template&id=4c5d1d80&"
import script from "./LvInfoBox.vue?vue&type=script&lang=js&"
export * from "./LvInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./LvInfoBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports